import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: "us-east-1_vy2tVIwu5",
    ClientId: "3r9khsmjf6og4shet0hh95e1fu"
}

export default new CognitoUserPool(poolData);